import CommentDeleteNotificationContainer from './CommentDeleteNotification.container';
import CommentDeleteNotification from './CommentDeleteNotification';
export default CommentDeleteNotificationContainer(CommentDeleteNotification);
